import { render, staticRenderFns } from "./PlannedStopCard.vue?vue&type=template&id=0fc5f6ca"
import script from "./PlannedStopCard.vue?vue&type=script&lang=ts"
export * from "./PlannedStopCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports